import request from 'helpers/request';
import api from 'config';
import { COMPANY_API } from 'apis';
import { useMutation } from 'react-query';

// 엑셀 다운로드 내역 기본 경로 (식권대장 /main/excelDownloadList).
// 목록은 이 경로, 개별 파일 다운로드는 `${EXCEL_API_PATH}/{fileId}`.
export const EXCEL_API_PATH = '/addons/v1/excel';
// 정산관리(/service/finance) 전용 경로. 목록·다운로드 모두 이 경로를 쓰고 응답 규격은 EXCEL_API_PATH 와 동일
export const COMMON_EXCEL_API_PATH = '/common/v1/excel';

//엑셀 다운로드 내역
export const ExcelList = (params, path = EXCEL_API_PATH) =>
  request({
    url: api.config.companyAPI + path,
    params: params
  });

//polling 엑셀 다운로드 내역
export const pollingExcelList = async (params, path = EXCEL_API_PATH) => {
  const { data } = await COMPANY_API.get(path, { params });
  return data;
};

//계정관리 권한 sel
export const AuthStaffSel = (params) =>
  request({
    url: api.config.companyAPI + '/company/v1/admin',
    params: params
  });

//권환 사용자 추가
export const AuthStaffAdd = (params) => {
  return request({
    method: 'post',
    url: api.config.companyAPI + '/company/v1/admin/' + params.id,
    data: params
  });
};

//권한 사용자 변경
export const AuthStaffMod = (params) => {
  return request({
    method: 'put',
    url: api.config.companyAPI + '/company/v1/admin/' + params.id,
    data: params
  });
};

//권한 사용자 조회
export const AuthStaffDet = (params) =>
  request({
    url: api.config.companyAPI + '/company/v1/admin/' + params.id
  });

//권한 사용자 삭제
export const AuthStaffDel = (params) => {
  return request({
    method: 'delete',
    url: api.config.companyAPI + '/company/v1/admin/' + params.id,
    data: params
  });
};
